/**
 * Spanish translations for Papelitos.
 */
import { TranslationKey } from './en';

export const es: Record<TranslationKey, string> = {
  // --- Common ---
  teamA: 'Equipo A',
  teamB: 'Equipo B',
  back: '← Atrás',
  backToMenu: '← Volver al Menú',
  continue: 'Continuar',
  start: 'INICIAR',
  loading: 'Cargando...',
  connecting: 'Conectando...',
  player: 'jugador',
  players: 'jugadores',
  card: 'carta',
  cards: 'cartas',
  pts: 'pts',
  pt: 'pt',
  host: 'Anfitrión',
  you: 'tú',
  round: 'Ronda',
  min: 'min',
  waiting: 'Esperando',

  // --- Main Menu ---
  appTitle: 'Pah-peh-lee-tohs',
  appSubtitle: 'El juego de cartas para fiestas',
  singleDevice: 'Un Solo Dispositivo',
  hostMultiDevice: 'Crear Juego Multi-Dispositivo',
  joinGame: 'Unirse a Juego',
  rules: 'Reglas',
  decksAvailable: '{0} mazos disponibles',
  cardsTotal: '{0} cartas',

  // --- Rules ---
  rulesTitle: 'Reglas',
  rulesSubtitle: 'Cómo jugar',
  round1Title: 'Ronda 1 — Describir',
  round1Desc: 'Usa cualquier palabra para describir la carta, ¡pero NO puedes decir ninguna palabra del título!',
  round2Title: 'Ronda 2 — Una Palabra',
  round2Desc: 'Di exactamente UNA palabra. ¡Sin gestos!',
  round3Title: 'Ronda 3 — Actuar',
  round3Desc: '¡Solo actuación física. Sin palabras!',
  round4Title: 'Ronda 4 — Dibujar',
  round4Desc: 'Dibuja en la pantalla. ¡Sin letras ni números!',
  optional: 'Opcional',

  // --- Round Rules (used in-game) ---
  roundName1: 'Describir',
  roundName2: 'Una Palabra',
  roundName3: 'Actuar',
  roundName4: 'Dibujar',
  roundDesc1: 'Usa cualquier palabra para describir la carta — ¡pero NO puedes decir ninguna palabra del título!',
  roundDesc2: 'Di exactamente UNA palabra para que tu equipo adivine. ¡Sin gestos!',
  roundDesc3: '¡Solo actuación física. No se permiten palabras!',
  roundDesc4: '¡Dibuja el título de la carta en pantalla. Sin letras ni números!',

  // --- Lobby ---
  gameLobby: 'Sala de Espera',
  lobbySubtitle: 'Agrega jugadores y asigna equipos',
  playerNamePlaceholder: 'Nombre del jugador',
  add: 'Agregar',
  playersAdded: '{0} jugador{1} agregado{1}',
  needAtLeast4: '(se necesitan al menos 4)',
  unassignedDragHint: 'Sin asignar — arrastra a un equipo',
  dropPlayersHere: 'Arrastra jugadores aquí',
  startGame: 'Iniciar Juego',
  removePlayer: 'Eliminar jugador',
  nameTaken: 'Nombre ya en uso',
  nameTooLong: 'El nombre debe tener 1-20 caracteres',
  gameFull: 'Juego lleno (máximo 20 jugadores)',

  // --- Setup ---
  gameSetup: 'Configuración',
  setupSubtitle: 'Configura tu juego',
  chooseDeck: 'Elige un mazo',
  customDeck: 'Mazo Personalizado',
  customDeckDesc: 'Cada jugador contribuye sus propias cartas',
  timerPerTurn: 'Tiempo por turno',
  cardsPerPlayer: 'Cartas por jugador',
  totalDeck: 'Mazo total: {0} jugadores × {1} = {2} cartas',
  playerOrder: 'Orden de jugadores',
  shuffle: 'Aleatorio',
  define: 'Definir',
  enableRound4: 'Habilitar Ronda 4 (Dibujar)',
  confirmAndPlay: 'Confirmar y Jugar',
  backToLobby: '← Volver a la Sala',
  pleaseSelectDeck: 'Por favor selecciona un mazo',

  // --- Round Interstitial ---
  roundN: 'RONDA {0}',
  letsGo: '¡Vamos!',
  startingIn: 'Empieza en {0}...',

  // --- Turn Waiting ---
  passPhoneTo: 'Pasa el teléfono a',
  nextPlayer: 'Siguiente Jugador',
  team: 'Equipo {0}',

  // --- Turn Active ---
  deckEmpty: '¡Mazo Vacío!',
  deckEmptyDesc: 'Todas las cartas se han jugado esta ronda.',
  cardsRemaining: '{0} carta{1} restante{1}',
  skip: 'Saltar',
  next: 'Siguiente →',

  // --- Turn End ---
  timesUp: '¡Se acabó el tiempo!',
  cardsCorrect: 'Cartas correctas',
  pointsEarned: 'Puntos ganados',
  cardsSkipped: 'Cartas saltadas',
  pointsLost: 'Puntos perdidos',
  protestACard: 'Protestar una Carta',
  nextUp: 'Siguiente',
  waitingForHost: 'Esperando al anfitrión...',

  // --- Protest ---
  protest: 'Protesta',
  protestSubtitle: '¿Fue válida la respuesta?',
  protestUpheld: 'Protesta aceptada — puntos eliminados',
  protestDismissed: 'Rechazada — puntos mantenidos',
  teamsDisagreeHostDecides: 'Los equipos no están de acuerdo — el Anfitrión decide:',
  teamASays: 'Equipo A dice:',
  teamBSays: 'Equipo B dice:',
  valid: 'Válida ✓',
  invalid: 'Inválida ✗',
  skipAllContinue: 'Omitir Todo y Continuar',
  doneContinue: 'Listo — Continuar',
  protested: 'Protestada',
  protestThisCard: 'Protestar Esta Carta',

  // --- Round Complete ---
  roundComplete: '¡Ronda {0} Completada!',
  seeFinalResults: 'Ver Resultados Finales',
  nextRound: 'Siguiente Ronda →',
  totalA: 'Total A',
  totalB: 'Total B',

  // --- Game End ---
  gameOver: 'Fin del Juego',
  teamAWins: '¡Equipo A Gana!',
  teamBWins: '¡Equipo B Gana!',
  itsATie: '¡Empate!',
  playAgain: 'Jugar de Nuevo',
  mainMenu: 'Menú Principal',

  // --- Custom Deck ---
  customDeckTitle: 'Mazo Personalizado',
  cardsPerPlayerLabel: '{0} cartas por jugador',
  passPhoneToPlayer: 'Pasa el teléfono a:',
  imReady: 'Estoy Listo',
  progressLabel: 'Progreso: {0}/{1} jugadores listos',
  playerCards: 'Cartas de {0}',
  titleRequired: 'Título (obligatorio)',
  titlePlaceholder: '¿Qué adivinarán?',
  descriptionOptional: 'Descripción (opcional)',
  descPlaceholder: 'Una pista',
  points: 'Puntos',
  addCard: 'Agregar Carta ✓',
  cardsAdded: 'Cartas agregadas:',
  doneSubmitAll: 'Listo — Enviar Todo',
  cardsSaved: '✓ ¡Cartas Guardadas!',
  allPlayersSubmitted: '¡Todos los jugadores han enviado sus cartas!',
  totalCardsReady: '{0} cartas totales listas',
  startPlaying: '¡A Jugar!',
  passToNextPlayer: 'Pasa el teléfono al siguiente jugador',
  doNotScrollUp: 'NO desplaces hacia arriba',
  titleRequiredError: 'El título es obligatorio',
  titleTooLong: 'El título debe tener 80 caracteres o menos',
  cardAlreadyAdded: 'Ya agregaste esta carta',

  // --- Mid-Round Transition ---
  allCardsGuessed: '¡Todas las cartas adivinadas!',
  continuesWith: '{0} continúa con',
  remaining: 'restante',

  // --- Multi Lobby ---
  newGame: 'Nuevo Juego',
  enterNameToHost: 'Ingresa tu nombre para ser anfitrión',
  yourNamePlaceholder: 'Tu nombre',
  createGame: 'Crear Juego',
  shareThisCode: 'Comparte este código',
  playersConnected: '{0} jugador{1} conectado{1}',
  unassignedTapToAssign: 'Sin asignar — toca para asignar',
  addPlayerWithoutPhone: 'Agregar jugador sin teléfono',
  addPlayer: 'Agregar Jugador',
  leaveGame: 'Salir del Juego',
  joinGameTitle: 'Unirse a Juego',
  enterCodeSubtitle: 'Ingresa el código de 4 dígitos',
  join: 'Unirse',
  joinAsReader: 'Unirse como Lector 📱',
  joinAsScoreboard: 'Unirse como Marcador 📊',
  enterValidCode: 'Ingresa un código válido de 4 dígitos',
  cannotConnect: 'No se puede conectar al servidor. ¿Está ejecutándose el backend?',
  waitingForHostToStart: 'Esperando a que el anfitrión inicie...',
  hostWillAssign: 'El anfitrión te asignará a un equipo',
  maxChars: 'Máximo 20 caracteres',
  connectedDevices: 'Dispositivos Conectados',
  yourRole: 'Tu rol',

  // --- Multi Gameplay ---
  hostIsChoosing: 'El anfitrión está eligiendo la configuración...',
  deck: 'Mazo',
  timer: 'Tiempo',
  rounds: 'Rondas',
  order: 'Orden',
  notSelected: 'No seleccionado',
  firstUp: 'Primero:',
  yourTurn: '¡Tu Turno!',
  pressStartWhenReady: 'Presiona INICIAR cuando estés listo',
  nextUpColon: 'Siguiente:',
  waitingForThemToStart: 'Esperando a que inicie...',
  startForThem: 'Iniciar por ellos (Anfitrión)',
  isDescribing: '{0} está describiendo...',
  isReading: 'está leyendo',
  waitingForFirstCard: 'Esperando la primera carta...',
  lastCorrect: 'Última correcta:',
  cardsProtested: '{0} carta{1} protestada{1} este turno',
  loadingCard: 'Cargando carta...',
  allCardsSubmitted: '¡Todas las cartas enviadas! Iniciando juego...',
  waitingForAllPlayers: 'Esperando a todos los jugadores...',
  waitingForNextPlayer: 'Esperando al siguiente jugador...',
  waitingForGameToStart: 'Esperando a que inicie el juego...',
  currentlyEntering: '{0} está ingresando cartas...',
  entering: 'ingresando...',
  lendPhoneTo: 'Presta tu teléfono a:',
  lendTo: 'Prestar a {0}',
  handPhoneTo: 'Entrega este teléfono a',
  theyWillEnterCards: 'Ingresarán sus cartas en privado.',
  yourCardsAreSafe: 'Tus cartas están seguras y ocultas.',
  imPlayerStart: 'Soy {0} — Comenzar',
  handPhoneBackTo: 'Devuelve el teléfono a {0}',
  done: 'Listo',
  pending: 'pendiente',
  customDeckProgress: 'Progreso del Mazo',
  playersSubmitted: '{0}/{1} jugadores enviaron',
  selectPlayerToEnter: 'Selecciona un jugador para ingresar sus cartas:',
  progress: 'Progreso',

  // --- Validation ---
  needPlayers: 'Se necesitan al menos {0} jugadores (hay {1})',
  playersUnassigned: '{0} jugador(es) sin asignar a un equipo',
  teamNeedsPlayers: 'Equipo {0} necesita al menos {1} jugadores',

  // --- Rejoin & QR ---
  rejoinGame: 'Volver al juego',
  scanToJoin: 'Escanea para unirte',

  // --- Reader Disconnect ---
  readerDisconnected: 'Lector Desconectado',
  readerDisconnectedDesc: 'El dispositivo Lector perdio conexion. El temporizador esta pausado.',
  waitingForReaderReconnect: 'Esperando que el Lector se reconecte...',
  assignNewReader: 'Asignar Nuevo Lector',
  readerTimeout: 'El Lector no se reconecto. Puedes asignar un nuevo dispositivo Lector.',
};
